import { faCheckSquare, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { GetLogsForUser, GetProjectLogTabs } from '../services/api';
import { LogEntry } from '../types/logEntry';
import { Tab as ProjectLogTab } from '../types/tab';
import moment from 'moment';
import './ListSection.css'

export default function ListSection(props: any) {
    let projectCells: HTMLTableDataCellElement[] = [];

    const [logs, setLogs] = useState<LogEntry[]>([]);
    const [tabs, setTabs] = useState<ProjectLogTab[]>([]);
    const [defaultTab, setDefaultTab] = useState<string>('');

    useEffect(() => {
        if (props.logEntry)
            setLogs(prevLogs => [...prevLogs, props.logEntry].sort((a, b) => b.detailsId - a.detailsId));
    }, [props.logEntry]);

    useEffect(() => {
        if (props.newProject) {
            const detailsId = props.newProject.detailsId | 0;

            setLogs(prevLogs => {
                const logIndex = prevLogs.findIndex((log: LogEntry) => log.detailsId === detailsId);

                if (logIndex > -1) {
                    prevLogs[logIndex].projectNumber = props.newProject.projectNumber;
                }

                return [...prevLogs].sort((a, b) => b.detailsId - a.detailsId);
            });
        }
    }, [props.newProject]);

    useEffect(() => {
        if (props.headerId) {
            GetLogsForUser(props.headerId)
                .then(logs => setLogs(logs.sort((a: any, b: any) => b.detailsId - a.detailsId)));

            GetProjectLogTabs()
                .then(tabs => {
                    const usersTab = tabs.find((tab: ProjectLogTab) => tab.username === props.username);

                    if (usersTab)
                        setDefaultTab(usersTab.locationName);
                    else
                        setDefaultTab('All');

                    setTabs(tabs);
                });
        }
    }, [props.headerId]);

    const renderTab = (tabData: LogEntry[], tab: ProjectLogTab) => {
        const count = tabData.filter((logEntry: LogEntry) => logEntry.projectNumber === null || logEntry.projectNumber === "").length;

        const title = count > 0
            ? <span>{tab.locationName} <Badge pill variant="danger">{count}</Badge></span>
            : <span>{tab.locationName}</span>
                                                                                //This was added later and MIGHT need to be deleted 
        return (
            <Tab key={`tab_${tab.id}`} eventKey={tab.locationName} title={title} tabClassName={defaultTab === tab.locationName ? 'default-tab' : undefined}>
                {tabData && tabData.map((logEntry: LogEntry, rowNumber: number) => renderRow(logEntry, rowNumber))}
            </Tab>
        )
    }

    const renderRow = (logEntry: LogEntry, rowNumber: number) => {
        return (
            <Row key={logEntry.createTime} style={{ marginBottom: 10, backgroundColor: logEntry.projectNumber === null || logEntry.projectNumber === "" ? 'rgba(255, 0, 0, 0.125)' : 'rgba(0, 255, 0, 0.125)' }}>
                <Col>
                    <Row>
                        <Col sm={1}><b>Time:</b>{moment(logEntry.createTime).format('MM/DD HH:mm')}</Col>
                        <Col sm={2}><b>Customer:</b>{logEntry.customerName}</Col>
                        <Col sm={2}><b>Rep:</b>{logEntry.customerRep}</Col>
                        <Col sm={2}><b>Barges:</b>{logEntry.barges}</Col>
                        <Col sm={2}><b>Boat:</b>{logEntry.boatName}</Col>
                        <Col sm={2}><b>Facility:</b>{`${logEntry.locationName} / ${logEntry.portName}`}</Col>
                    </Row>
                    <Row>
                        <Col sm={2}><b>Dock:</b>{logEntry.dockNo}</Col>
                        <Col sm={2}><b>Product:</b>{logEntry.productName}</Col>
                        <Col sm={2}><b>Product Alias:</b>{logEntry.alias}</Col>
                        <Col sm={2}><b>Draft:</b>{logEntry.draft}</Col>
                        <Col sm={2}><b>PO:</b>{logEntry.poNumber}</Col>
                        <Col sm={1}><b>H2S:</b>{logEntry.h2S ? <FontAwesomeIcon icon={faCheckSquare} /> : 'NO'}</Col>
                        <Col sm={1}><b>Firm:</b>{logEntry.firm ? <FontAwesomeIcon icon={faCheckSquare} /> : 'NO'}</Col>
                    </Row>
                    <Row>
                        <Col sm={1}><b>ETA</b>{logEntry.eta}</Col>
                        <Col sm={1} data-details-id={logEntry.detailsId}>
                            <table>
                                <tr>
                                    <td style={{ fontWeight: "bold" }}>Project:</td>
                                    <td data-details-id={logEntry.detailsId} ref={(ref: HTMLTableDataCellElement) => projectCells[logEntry.detailsId] = ref} >{logEntry.projectNumber}</td>
                                </tr>
                            </table>
                        </Col>
                        <Col sm={5}><b>Project Descr:</b>{logEntry.projectDesc}</Col>
                        <Col sm={5}><b>Comments:</b>{logEntry.comment}</Col>
                    </Row>
                </Col>
            </Row>
        );
    }

    if (defaultTab !== '') {
        return (
            <Container fluid>
                <h5>
                    <FontAwesomeIcon icon={faList} /> Pending Projects <Badge pill variant="danger">{logs.filter((logEntry: LogEntry) => logEntry.projectNumber === null || logEntry.projectNumber === "").length}</Badge>
                </h5>
                <Row >
                    <Col>
                        <Tabs defaultActiveKey={defaultTab} id="uncontrolled-tab-example" className="mb-3">
                            {renderTab(logs, { locationName: 'All' })}

                            {logs && tabs.map((tab: ProjectLogTab) => {
                                const tabData = logs.filter((logEntry: LogEntry) => logEntry.username === tab.username);
                                return renderTab(tabData, tab);
                            })}
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        );
    } else {
        return null;
    }
}